jQuery(document).ready(function ($) {

    var w = $(window).width();
    var h = $(window).height();
    var h_out = $(window).outerHeight();
    $('span.width').html(w + 15);
    $('span.height').html(h);

    $(window).resize(function () {
        var w = $(window).width();
        var h = $(window).height();
        $('span.width').html(w + 15);
        $('span.height').html(h);
    });

    $(window).scroll(function () {
        var pos = $(document).scrollTop();
        $("span.scroll").html('Scroll: ' + pos);
        if (pos > 0) {
            $('header nav').addClass('scrolled');
        }else{
            $('header nav').removeClass('scrolled');
        }

        if (pos > 600) {
            $('.back-to-top').addClass('show');
        }else{
            $('.back-to-top').removeClass('show');
        }
    });
});

// Nasłuchuj zdarzenia scroll
    window.addEventListener('scroll', function () {
      const pos = window.scrollY || document.documentElement.scrollTop;
      const backToTop = document.querySelector('.back-to-top');

      if (backToTop) {
        if (pos > 300) {
          backToTop.classList.add('active'); // Dodaje klasę 'active', gdy scroll > 300
        } else {
          backToTop.classList.remove('active'); // Usuwa klasę 'active', gdy scroll ≤ 300
        }
      }
    });

    // Dodajemy klik tylko raz po załadowaniu DOM
    document.addEventListener('DOMContentLoaded', function () {
      const backToTop = document.querySelector('.back-to-top');
      if (backToTop) {
        backToTop.addEventListener('click', function (event) {
          event.preventDefault();
          window.scrollTo({ top: 0, behavior: 'smooth' });
        });
      }
    });